import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { I18nService } from '../i18n/i18n.service';
import { BrowserPlatformService } from '../browser-platform/browser-platform.service';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    private _i18n = inject(I18nService);
    private _browser = inject(BrowserPlatformService);

    private contentUrl = '';

    constructor() {
        const _i18n = this._i18n;

        if (this._browser.isBrowser) {
            this.contentUrl = AppGlobalsModule.warehousePath('BeaconData', _i18n.getLang());
        }
    }

    public storeData(key: string, value: string): Observable<void> {
        // TODO: Save in warehouse

        // let data = `${key}=${value}`;
        // navigator.sendBeacon(this.contentUrl, data);

        this._browser.localStorage?.setItem(key, value);
        return of(undefined);
    }

    public fetchData(key: string, cloud = false): Observable<any> {
        return of(this._browser.localStorage?.getItem(key) || 0);
    }

    public getSimpleData(key: string, cloud = false): string {
        return this._browser.localStorage?.getItem(key) || '0';
    }

    public load(key: string): any {
        const storage = this._browser.localStorage;
        if (!storage) {
            return;
        }
        var val: any = storage.getItem(key);
        return val ? JSON.parse(val) : null;
    }

    public store(key: string, val: any): void {
        const storage = this._browser.localStorage;
        if (!storage) {
            return;
        }
        storage[key] = JSON.stringify(val);
    }

}
